import React, { memo, useCallback, useMemo } from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';

import { OEButton, OEButtonProps } from '../../atoms/oe-button/oe-button';
import { flex, fs, mt, opacity, minWidth, mr, width } from '../../style-utils';
import { ErrorMessageBox } from '../error-message-box/error-message-box';

type FooterButtonType = {
  label: string;
} & Pick<
  OEButtonProps,
  'loading' | 'disabled' | 'onPress' | 'style' | 'labelStyle'
>;

export type FormFooterProps = {
  buttonSubmit: FooterButtonType;
  buttonCancel?: FooterButtonType;
  error?: string;
  style?: StyleProp<ViewStyle>;
};

const FormFooter = ({
  buttonSubmit,
  error,
  buttonCancel,
  style,
}: FormFooterProps) => {
  const buttonLabelStyle = useMemo(() => [fs(18)], []);

  const renderCancelButton = useCallback(() => {
    if (!buttonCancel) {
      return null;
    }
    return (
      <OEButton
        onPress={buttonCancel.onPress}
        mode="outlined"
        style={[mr(10), buttonCancel?.style]}
        labelStyle={[buttonLabelStyle, buttonCancel?.labelStyle]}
      >
        {buttonCancel.label}
      </OEButton>
    );
  }, [buttonCancel, buttonLabelStyle]);

  return (
    <View style={[width('100%')]}>
      {error ? <ErrorMessageBox text={error} style={[mt(38)]} /> : null}
      <View
        style={[
          mt(38),
          flex(
            'flex-row',
            buttonCancel ? 'justify-content-end' : 'justify-content-center'
          ),
          style,
        ]}
      >
        {renderCancelButton()}
        <OEButton
          onPress={buttonSubmit.onPress}
          loading={buttonSubmit.loading}
          disabled={buttonSubmit.disabled || buttonSubmit.loading}
          style={[
            opacity(buttonSubmit.loading ? 0.5 : 1),
            !buttonCancel && minWidth(150),
            !buttonSubmit.disabled && buttonSubmit?.style,
          ]}
          labelStyle={[
            buttonLabelStyle,
            !buttonSubmit.disabled && buttonSubmit?.labelStyle,
          ]}
        >
          {buttonSubmit.label}
        </OEButton>
      </View>
    </View>
  );
};

export default memo(FormFooter);
